import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
} from 'react-icons/fa';

export const socialLinks = [
  {
    id: 'github',
    icon: FaGithub,
    url: "https://github.com/sushantpardhi",
    label: 'GitHub',
  },
  {
    id: 'linkedin',
    icon: FaLinkedin,
    url: 'https://www.linkedin.com/in/sushantpardhi/',
    label: 'LinkedIn',
  },
  {
    id: 'email',
    icon: FaEnvelope,
    url: 'mailto:sushantgpardhi@gmail.com',
    label: 'Email',
  },
];
